<template>
  <div>
    <v-card>
      <v-col>
        <div v-if="!hide_account_filter && accounts.length > 1">
          <account-switch
            :accounts="accounts"
            @switch_account="switch_account($event.account_id)"
          ></account-switch>
        </div>

        <div v-show="!hide_date_filter">
          <span class="pa-2 ma-2">Filter by date</span>

          <v-row class="pl-5">
            <date-picker
              @change="
                start_date = $event;
                applyFilters();
              "
              label="Start Date"
              textColor="primary"
              dateColor="primary"
              dateBtnColor="primary"
              :validate="true"
              ref="startDatePicker"
              class="pt-6 pr-8"
            ></date-picker>

            <date-picker
              @change="
                end_date = $event;
                applyFilters();
              "
              label="End Date"
              textColor="primary"
              dateColor="primary"
              dateBtnColor="primary"
              :validate="true"
              ref="endDatePicker"
              class="pt-6 pl-8"
            ></date-picker>
          </v-row>
        </div>

        <div v-if="!hide_active_filter">
          <span class="pa-2 ma-2">Filter by active</span>
          <br />

          <v-switch
            class="px-8"
            v-model="active_only"
            :label="`Active Only`"
            @change="applyFilters()"
          ></v-switch>
        </div>

        <div v-show="!hide_sort_filter">
          <br />
          <span class="pa-2 ma-2">Sort {{ view }}s by</span>
          <br />

          <v-radio-group v-model="sort" @change="applyFilters()" class="pl-7">
            <v-radio label="Oldest" value="asc"></v-radio>

            <v-radio label="Most Recent" value="desc"></v-radio>
          </v-radio-group>
        </div>

        <div>
          <br />
          <span class="pa-2 ma-2">Filter by value</span>
          <v-spacer class="pt-2"></v-spacer>

          <order-filters
            v-if="view === 'order'"
            @build_filter="build_filter($event.field, $event.value)"
          ></order-filters>
          <select-filters
            v-if="view === 'select'"
            @build_filter="build_filter($event.field, $event.value)"
            @named_selects_only="set_named_selects_only($event.value)"
          ></select-filters>
          <account-filters
            v-if="view === 'account'"
            @build_filter="build_filter($event.field, $event.value)"
          ></account-filters>
          <user-filters
            v-if="view === 'user'"
            @build_filter="build_filter($event.field, $event.value)"
          ></user-filters>
          <creds-filters
            v-if="view === 'creds'"
            @build_filter="build_filter($event.field, $event.value)"
          ></creds-filters>
          <monitor-filters
            v-if="view === 'monitor'"
            @build_filter="build_filter($event.field, $event.value)"
          ></monitor-filters>
        </div>

        <v-row class="pl-10">
          <v-chip
            v-for="filter in filters"
            :key="filter"
            v-model="filters"
            @click="removeFilter(filter)"
          >
            {{ filter }}
            <v-icon right size="20"> mdi-alpha-x </v-icon>
          </v-chip>
        </v-row>
      </v-col>
    </v-card>
  </div>
</template>

<script>
import DatePicker from "@/components/shared/DatePicker.vue";
import OrderFilters from "@/components/order/OrderFilters.vue";
import SelectFilters from "@/components/select/SelectFilters.vue";
import AccountFilters from "@/components/account/AccountFilters.vue";
import UserFilters from "@/components/user/UserFilters.vue";
import CredsFilters from "@/components/credentials/CredsFilters.vue";
import MonitorFilters from "@/components/monitor/MonitorFilters.vue";
import AccountSwitch from "@/components/account/AccountSwitch.vue";

export default {
  props: {
    accounts: Array,
    read_only: Boolean,
    hide_date_filter: Boolean,
    hide_active_filter: Boolean,
    hide_sort_filter: Boolean,
    hide_account_filter: Boolean,
    view: String,
  },
  components: {
    DatePicker,
    OrderFilters,
    SelectFilters,
    AccountFilters,
    UserFilters,
    CredsFilters,
    MonitorFilters,
    AccountSwitch,
  },
  data() {
    return {
      filters: [],
      filter_value: "",
      start_date: "",
      end_date: "",
      sort: "desc",
      active_only: "true",
      selected_account: "",
      named_select_only: false,
    };
  },
  mounted() {
    this.syncFilters();
  },
  watch: {
    $route() {
      this.syncFilters();
    },
  },
  methods: {
    addFilter(filter) {
      this.filters.push(filter);
      this.filter_value = "";
      this.applyFilters();
    },

    removeFilter(filter) {
      const index = this.filters.indexOf(filter);
      if (index > -1) {
        this.filters.splice(index, 1);
      }
      this.applyFilters();
    },

    applyFilters() {
      this.$emit("apply_filters", {
        start_date: this.start_date,
        end_date: this.end_date,
        filters: this.filters,
        sort: this.sort,
        active_only: this.active_only,
        selected_account: this.selected_account,
        named_only: this.named_select_only,
      });
    },

    syncFilters() {
      // filters list with one item returns a string, cast to array
      let filters = this.$route.query.filters || [];
      this.$route.query.filters =
        typeof filters == "string" ? [filters] : filters;
      // sync filters with query params in router
      let query_params = JSON.parse(JSON.stringify(this.$route.query));
      this.sort = query_params.sort || "desc";
      this.filters = query_params.filters || [];
      this.selected_account =
        query_params.selected_account || this.$route.params.account_id;
      this.start_date = query_params.start_date || "";
      this.end_date = query_params.end_date || "";
      if (!this.hide_date_filter && (!this.start_date || !this.end_date)) {
        // set start and end date defaults
        this.setDefaultDates(query_params);
        return;
      }
      this.active_only = query_params.active_only || "true";
      // cast active only to boolean
      this.active_only = this.active_only === "true";
      this.$refs.startDatePicker.setDateValue(this.start_date);
      this.$refs.endDatePicker.setDateValue(this.end_date);
    },

    setDefaultDates(query_params) {
      var today = new Date();
      var priorDate = new Date().setDate(today.getDate() - 30);
      const start_date =
        query_params.start_date ||
        new Date(priorDate).toISOString().substring(0, 10);
      const end_date =
        query_params.end_date || today.toISOString().substring(0, 10);
      query_params["end_date"] = end_date;
      query_params["start_date"] = start_date;
      this.$router.replace({
        query: query_params,
      });
    },

    build_filter(field, filter_val) {
      var add_filter = true;
      this.filters = this.filters.filter(function (value) {
        return !value.startsWith(`${field}:`);
      });
      if (
        filter_val === undefined ||
        filter_val === "" ||
        filter_val === null
      ) {
        add_filter = false;
      }

      if (add_filter) {
        const filter = `${field}:${filter_val}`;
        this.filters.push(filter);
      }
      this.applyFilters();
    },

    switch_account(account_id) {
      // hard copy router query params
      let query_params = JSON.parse(JSON.stringify(this.$route.query));

      // remove the page query param since we are switching accounts so we can restart on page 1
      if (query_params.page) {
        delete query_params.page;
      }
      // remove the paging_id query param since we are switching accounts so we can restart on page 1
      if (query_params.paging_id) {
        delete query_params.paging_id;
      }

      // add selected account to query params
      query_params["selected_account"] = account_id;
      this.$router.push({
        params: { account_id: account_id },
        query: query_params,
      });
    },

    set_named_selects_only(value) {
      this.named_select_only = value;
      this.applyFilters();
    },
  },
};
</script>
